<template>
  <div class="index">
    <div class="webinar-reviews" v-if="reviewsObject">
      <h5 class="has-text-centered unpublished"><span>Неопубликованные отзывы {{unpublished.length}}</span></h5>
      <WebinarItem v-for="review in unpublished" :review="review" :key="review.id"/>
      <h5 class="has-text-centered published"><span>Опубликованные отзывы {{published.length}}</span></h5>
      <WebinarItem v-for="review in published" :review="review" :key="review.id"/>
    </div>
  </div>
</template>

<script>
import WebinarItem from 'components/Events/WebinarReviewItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import moment from 'moment'

export default {
  name: 'WebinarReviews',
  data () {
    return {
      published: [],
      unpublished: []
    }
  },
  computed: {
    ...mapState(['webinarsReviews']),
    reviewsObject () {
      const data = deepcopy(this.webinarsReviews)
      data.forEach((d) => {
        d.date = moment(d.date).format('ll')
        if (d.webinar.date) {
          d.webinar.date = moment(d.webinar.date).format('lll')
        }
      })
      this.published = data.filter(r => r.isPublished)
      this.unpublished = data.filter(r => !r.isPublished)
      return data
    }
  },
  created () {
    this.getWebinarReviews()
  },
  methods: {
    ...mapActions(['getWebinarReviews', 'deleteWebinarReview'])
  },
  components: { WebinarItem }
}
</script>

<style scoped>
.review span {
  display: block;
}
.review {
  margin: 25px 0;
  position: relative;
}
.review-block {
  background: #eee;
  padding: 15px 25px;
  margin-top: 5px;
}
.webinar-reviews {
  max-width: 800px;
  margin: 0 auto;
}
.review-date {
  text-align: right;
}
.review-name {
  font-weight: bold;
}
.review-text {
  margin: -15px 0 0;
}
.webinar-info {
  font-size: .9em;
}
.delete-icon {
  right: -13px;
  top: -13px;
}
.published span {
  color: #fff;
  background: #72bb53;
}
.unpublished span {
  color: #fff;
  background: #e61610;
  margin: 10px 0;
}
.published span,
.unpublished span {
  padding: 5px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// WebinarReviews.vue?9e0a0356